import { css } from 'styled-components';
import { rgba } from 'polished';
import { combineValues, globalTheme } from '@clds/component-theme';
import { focusVisible } from '@clds/style-utils';

const focusCss = css<{ assignFocusToAfter?: boolean }>`
  &${focusVisible()}${({ assignFocusToAfter }) => assignFocusToAfter && ':after'} {
    box-shadow: 0 0 0 3px ${combineValues(globalTheme.palette.primary, (color) => rgba(color, 0.5))};

    &:before {
      content: '';
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 100%;
    }
  }
`;

export default focusCss;
